module.exports = __webpack_public_path__ + "static/media/Recurso 4.cd689786.svg";